module.exports = __webpack_public_path__ + "static/Expert team-978f1cfa55f68f5d0921e111e497c195.png";